// api
import { fetchApi } from '@/api'
import router from '@/router'
// actions

const Formlogin = (context) => {
  let url = 'forms/login'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      context.commit('FORMLOGIN', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const login = (context, payload) => {
  let url = 'login'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('LOGIN', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const logout = (context) => {
  context.commit('LOGOUT')
}

export default {
  Formlogin,
  login,
  logout
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js